export enum DrugCardVariant {
  // use for search and categories pages
  SearchCard = 'SearchCard',
  // use for search on the third booking step
  SimpleSearchCard = 'SimpleSearchCard',
  // use for fast search component
  FastSearchCard = 'FastSearchCard',
  // use for fast search component on mobile
  FlatFastSearchCard = 'FlatFastSearchCard',
  // use for TopDrugs, ViewedDrugs, AnalogDrugs components
  MinimalisticCard = 'MinimalisticCard'
}
